import i18next from 'i18next';

import {
    ColorBluePrimary,
    ColorGreenPrimary,
    ColorOrangePrimary,
    ColorPurplePrimary,
    ColorRedPrimary
} from 'ui-connect/styles/default-theme';

// constants and conversion functions for power to weight ratio

export const ratings = {
    UNTRAINED: 'Untrained',
    FAIR: 'Fair',
    GOOD: 'Good',
    EXCELLENT: 'Excellent',
    SUPERIOR: 'Superior'
};

export const colors = {
    UNTRAINED: ColorRedPrimary,
    FAIR: ColorOrangePrimary,
    GOOD: ColorGreenPrimary,
    EXCELLENT: ColorBluePrimary,
    SUPERIOR: ColorPurplePrimary
};

export const CYCLING = 'cycling';
export const CROSS_COUNTRY_SKIING = 'cross_country_skiing';

export const getRating = (genderBenchmarks, value) => {
    const benchmarkList = Object.values(genderBenchmarks);
    const rating = benchmarkList.find(
        (data) => data.minValue <= value && (value <= data.maxValue || data.maxValue === 0)
    );

    if (rating === undefined) {
        return {
            key: 'superior',
            label: i18next.t('reportswidget:ftp.superior')
        };
    }

    return {
        key: rating.category_key || rating.category,
        label: rating.category_key ? i18next.t('reportswidget:ftp.' + rating.category_key) : rating.category
    };
};

export const limitDecimalPlaces = (num, digits = 1) => {
    const powerOfTen = 10 ** digits;
    return Math.round(num * powerOfTen) / powerOfTen;
};

// format power value for exported reports
export const formatValue = (value, unit) => `${limitDecimalPlaces(value, 2)} ${unit}`;
